export default __webpack_public_path__ + "static/media/dog.66f9d41e.png";